import { z } from 'zod';

const optionalLinkSchema = z.preprocess(
  (value) => {
    if (value == null) return '';
    if (typeof value === 'string') return value.trim();
    return String(value).trim();
  },
  z.string().refine(
    (value) => {
      if (!value) return true;

      try {
        const withProtocol = /^https?:\/\//i.test(value) ? value : `https://${value}`;
        const parsed = new URL(withProtocol);
        return ['http:', 'https:'].includes(parsed.protocol);
      } catch {
        return false;
      }
    },
    { message: 'Please enter a valid link' }
  )
);

export const brandingSchema = z
  .object({
    configuration: z
      .object({
        support_calendar: optionalLinkSchema
      })
      .passthrough()
      .nullish()
  })
  .passthrough();

export const llmSchema = z.object({
  configuration: z.object({
    default_llm_service: z.string({ message: 'LLM is required' }),
    default_stt_service: z.string({ message: 'STT is required' }),
    default_tts_service: z.string({ message: 'TTS is required' })
  })
});

export const stripeThirdPartySchema = z.object({
  configuration: z.object({
    secret_key: z.string().min(1, { message: 'Secret Key is required' }),
    publishable_key: z.string().min(1, { message: 'Publishable Key is required' }),
    webhook_secret: z.string().min(1, { message: 'Webhook Secret is required' }),
    product_price_id: z.string().min(1, { message: 'Product Price ID is required' }),
    auto_apply_promo_code: z.string().min(1, { message: 'Auto Apply Promo Code is required' })
  })
});

export const smtpSchema = z.object({
  configuration: z.object({
    smtp_username: z.string({ message: 'SMTP Username is required' }),
    smtp_password: z.string({ message: 'SMTP Password is required' }),
    smtp_address: z.string({ message: 'SMTP Address is required' }),
    smtp_domain: z.string({ message: 'SMTP Domain is required' }),
    smtp_port: z.coerce.number({ message: 'SMTP Port is required' }),
    smtp_from_name: z.string({ message: 'SMTP From Name is required' }),
    smtp_from: z
      .string({ message: 'SMTP From is required' })
      .email({ message: 'SMTP From must be a valid email address' })
  })
});

export const twilioSchema = z.object({
  active: z.boolean().optional(),
  friendly_name: z.string().optional(),
  configuration: z.object({
    ssid: z.string({ message: 'SSID is required' }),
    auth_token: z.string({ message: 'Auth Token is required' }),
    trunk_sid: z.string({ message: 'Trunk SID is required' }),
    termination_sip_uri: z.string({ message: 'Termination SIP URI is required' }),
    termination_username: z.string({ message: 'Termination Username is required' }),
    termination_password: z.string({ message: 'Termination Password is required' })
  })
});

export const netsapiensSchema = z.object({
  active: z.boolean().optional(),
  friendly_name: z.string().optional(),
  configuration: z.object({
    api_key: z.string({ message: 'Api key is required' })
  })
});

export const threeCxSchema = z.object({
  active: z.boolean().optional(),
  friendly_name: z.string().optional(),
  configuration: z.object({
    ssid: z.string({ message: 'SSID is required' }),
    auth_token: z.string({ message: 'Auth Token is required' })
  })
});
